import type { FC } from 'react';
import { IntlProvider } from 'react-intl';

import { useConfiguration } from '~/shared/contexts/configurationContext';
import { useLocalizations } from '~/shared/hooks/useLocalizations';

export const I18nContainer: FC = ({ children }) => {
  const { currentLanguage } = useConfiguration();
  const { data: localization } = useLocalizations();

  const messages = localization?.translations[currentLanguage] ?? {};

  if (!localization) {
    return null;
  }

  return (
    <IntlProvider
      locale={currentLanguage}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};
